import dayjs from 'dayjs'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'

interface FormattedExelyCancellationDeadline {
  date: string
  hours: string
}

export const formatExelyCancellationDeadline = (
  deadline?: string | null,
): FormattedExelyCancellationDeadline | null => {
  if (!deadline) {
    return null
  }

  const parsedDeadline = dayjs(deadline)

  if (!parsedDeadline.isValid()) {
    return null
  }

  return {
    date: parsedDeadline.format(DATE_FORMAT_LIST.FULL_DATE),
    hours: parsedDeadline.format(DATE_FORMAT_LIST.TIME),
  }
}
